import { render } from "./ZhenQiView.vue?vue&type=template&id=31acfe74&scoped=true"
import script from "./ZhenQiView.vue?vue&type=script&lang=js"
export * from "./ZhenQiView.vue?vue&type=script&lang=js"

import "./ZhenQiView.vue?vue&type=style&index=0&id=31acfe74&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31acfe74"]])

export default __exports__